<template>
  <va-card>
    <template slot="header">
      <div class="va-card__header-title" color="secondary">
        <span v-if="$route.params.id">
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/kampanya/listesi">{{ $t('menu.campaigns') }}</router-link> / {{ item.name }}
        </span>
        <span v-else>
          <router-link to="/">{{ $t('menu.dashboard') }}</router-link> / <router-link to="/kampanya/listesi">{{ $t('menu.campaigns') }}</router-link> / {{ $t('tables.actions.create') }}
        </span>
      </div>
      <div class="va-card__header-actions"/>
    </template>
    <form @submit.prevent="onsubmit">
      <div class="row">
        <div class="flex md6 xs12">
          <div class="row">
            <div v-if="!!item.image_paths_readable && !!item.image_paths_readable.tr" class="flex xs12 text--center">
              <img :src="item.image_paths_readable.tr" style="width:100%;height:auto;max-width:900px;max-height:450px"/>
            </div>
          </div>
          <div class="row">
            <div class="flex xs12 text--center">
              <input
                type="file"
                name="image"
                accept="image/*"
                style="display:none"
                ref="campaignInputFileTr"
                @change="setImage"
              >
              <va-button type="button" small color="warning" @click.stop="handleFileInput" v-text="!!item && !!item.id ? 'Yerine Fotoğraf Seç' : 'Fotoğraf Seç'"/>
            </div>
          </div>
        </div>
        <div class="flex md6 xs12">
          <div class="row">
            <div v-if="!!image && JSON.stringify(image) !== JSON.stringify({})" class="flex xs12 text--center">
              <vue-cropper
                ref="cropper"
                :src="image.url"
                :rotatable="true"
                :view-mode="2"
                :aspectRatio="9/4"
                drag-mode="crop"
                v-model="croppaImage"
                :img-style="{'width': '100%', 'height': '100%', 'max-width': '900px', 'max-height': '450px'}"
                :width="900"
                :height="450"
                :accept="'image/*'"
                :file-size-limit="1500000"
              />
              <va-popover message="Resmi Döndür" placement="bottom" :disabled="isMobile">
                <va-button type="button" small color="info" icon="fa fa-rotate-left" @click.stop="rotateCroppaImage()">Döndür</va-button>
              </va-popover>
              <va-popover message="Resmi Sil" placement="bottom" :disabled="isMobile">
                <va-button type="button" small color="danger" icon="fa fa-close" @click.stop="deleteCroppaImage()">Sil</va-button>
              </va-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <va-input
            v-model="form.name"
            label="İsim"
            placeholder="Kampanya ismi girin"
            required
          />
        </div>
        <div class="flex md6 sm6 xs12">
          <va-input
            v-model="form.title"
            label="Başlık"
            placeholder="Kampanya başlığı girin"
            required
          />
        </div>
        <div class="flex xs12">
          <va-input
            type="textarea"
            v-model="form.description"
            label="Açıklama"
            placeholder="Kampanya açıklaması girin"
            required
          />
        </div>
      </div>
      <div class="row">
        <div class="flex xs12 md4">
          <va-date-picker
            v-model="range"
            label="Başlangıç - Bitiş Tarihi"
            :config="{mode: 'range', inline: true}"
            id="datePickerRange"
          />
        </div>
        <div class="flex md8 sm8 xs12">
          <div class="row">
            <div class="flex md3 xs12">
              <fieldset>
                <va-radio-button
                  option="decrease"
                  v-model="form.apply_type"
                  label="Azalt"
                />
                <va-radio-button
                  option="increase"
                  v-model="form.apply_type"
                  label="Artır"
                />
              </fieldset>
            </div>
            <div class="flex md6 xs12">
              <va-input
                type="number"
                step="any"
                v-model="form.amount"
                label="Tutar"
                placeholder="Tutar girin"
                required
              />
            </div>
            <div class="flex md3 xs12">
              <fieldset>
                <va-radio-button
                  option="percent"
                  v-model="form.amount_type"
                  label="%"
                />
                <va-radio-button
                  option="amount"
                  v-model="form.amount_type"
                  label="₺"
                />
              </fieldset>
            </div>
          </div>
          <div class="row">
            <div class="flex xs12">
              <div id="vueSelectVehiclesDiv">
                <p class="title ml-2">Kampanyaya Dahil Araçlar</p>
                <v-select
                  label="name_readable"
                  value="id"
                  :options="vehicles"
                  id="city"
                  v-model="item.vehicles"
                  autocomplete="off"
                  required
                  multiple
                >
                  <slot name="spinner">
                    <div class="spinner">Yükleniyor...</div>
                  </slot>
                  <span slot="no-options">Eşleşen seçenek bulunmuyor</span>
                </v-select>
                <va-button type="button" small color="info" @click.stop="selectAllVehicles">Bütün Araçları Seç</va-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <va-button type="submit">Kaydet</va-button>
      </div>
    </form>
  </va-card>
</template>

<script>
import vehicleServices from '../../services/api/vehicle'
import campaignServices from '../../services/api/campaign'
import uploadServices from '../../services/api/upload'
import responseMixin from '../../services/api/response'
import helperMixin from '../../services/helper'
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
  mixins: [responseMixin, helperMixin],
  components: { VueCropper },
  data () {
    return {
      isMobile: false,
      item: {
        vehicles: []
      },
      form: {
        language: 'tr',
        image_path: null,
        name: '',
        title: '',
        description: '',
        start_at: '',
        end_at: '',
        range: '',
        vehicles: [],
        apply_type: 'decrease',
        amount_type: 'percent',
        amount: null,
      },
      vehicles: [],
      croppaImage: {},
      image: {},
      imageReady: false,
      range: ''
    }
  },
  watch: {
    '$route': function(val) {
      this.form = {language: 'tr', image_path: null, name: '', title: '', description: '', start_at: '', end_at: '', range: '', vehicles: [], apply_type: 'decrease', amount_type: 'percent', amount: null};
      this.vehicles = [];
      this.item = {vehicles: []};
      this.range = '';
      this.getVehicles();
      if(val.params.id) {
        this.getCampaign(val.params.id);
      }
    },
    'imageReady': function(val) {
      if(val) {
        if(this.$route.params.id) {
          this.putCampaign(this.$route.params.id);
        }
        else {
          this.postCampaign();
        }
      }
    },
    'item.vehicles': function(val) {
      this.form.vehicles = val;
      if(!!val && val.length > 0) {
        this.form.vehicles = (val).map(iv => iv.id);
      }
    },
    'range': function(val) {
      if(val) {
        this.form.range = val;
        let formRangeArray = (val).split(' - ');
        this.form.start_at = formRangeArray[0];
        this.form.end_at = formRangeArray[1];
      }
    },
  },
  methods: {
    async getVehicles(){
      const result = await vehicleServices.get('', {
          params: {
            'limit':10000,
            'page':1
          }
        });
      if(result.error){
        this.vehicles = [];
        return ;
      }
      this.vehicles = result.data.data;
    },
    async getCampaign(id){
      const result = await campaignServices.get(id, {
          params: {
            'include':'vehicles'
          }
        });
      if(result.error){
        return ;
      }
      this.item = result.data.data;
      this.form = JSON.parse(JSON.stringify(this.item));
      this.form.language = 'tr';
      this.form.title = this.item.title.tr;
      this.form.description = this.item.description.tr;
      this.form.range = this.item.start_at + ' - ' + this.item.end_at;
      this.range =  this.form.range;
      this.form.image_path = this.item.image_paths.tr;
      this.form.image_url = this.item.image_url ? this.item.image_url : null;
      this.form.vehicles = this.item.vehicles;
    },
    async uploadImage(image) {
      let uploadData = {
        path: 'campaigns', 
        file: image
      };
      uploadData = window.jsonToFormData(uploadData);
      const res = await uploadServices.post({
        data: uploadData,
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res, 'fa-upload', 'Fotoğraf yükleme');
        return ;
      }
      this.responseToast('POST', 'success', res, 'fa-upload', 'Fotoğraf yükleme');
      this.form.image_url = res.data.data.cdn_url;
      this.form.image_path = res.data.data.path;
      this.imageReady = true;
    },
    async postCampaign() {
      const res = await campaignServices.post({
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('POST', 'error', res);
        this.imageReady = false;
        return ;
      }
      this.responseToast('POST', 'success');
      this.redirectTo('/kampanya/'+res.data.data.id, 2500);
    },
    async putCampaign(id) {
      const res = await campaignServices.put(id, {
        data: this.form
      });
      if(res.error){
        //error handling
        this.responseToast('PUT', 'error', res);
        this.imageReady = false;
        return ;
      }
      this.responseToast('PUT', 'success');
    },
    async onsubmit () {
      //validation
      if(!!this.image && JSON.stringify(this.image) !== JSON.stringify({})) {
        await this.resolveImage(s => {});
      }
      else {
        this.imageReady = true;
      }
    },
    handleFileInput() {
      this.deleteCroppaImage();
      this.$refs.campaignInputFileTr.click();
    },
    setImage(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Lütfen resim dosyası seçiniz.");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          var img = {};
          img.url = URL.createObjectURL(file);
          img.name = file.name;
          this.image = img;
        };
        reader.readAsDataURL(file);
      }
    },
    rotateCroppaImage() {
      this.croppaImage = this.$refs.cropper.rotate(90);
    },
    deleteCroppaImage() {
      this.image = {};
      this.croppaImage = {};
    },
    async resolveImage(callback) {
      let file = null;
      if (this.image) {
        await this.$refs.cropper
          .getCroppedCanvas()
          .toBlob(blob => {
            file = new File([blob], "file_name", { lastModified: 1534584790000 });
            this.uploadImage(file);
            callback();
          });
      }
    },
    selectAllVehicles() {
      this.item.vehicles =  this.vehicles;
    }
  },
  created () {
    this.isMobile = this.checkIsMobile();
    this.getVehicles();
    if(this.$route.params.id) {
      this.getCampaign(this.$route.params.id);
    }
  },
}
</script>

<style lang="scss">
#vueSelectVehiclesDiv {
  position: relative;
  .title {
    position: absolute;
    z-index: 1;
    top: 2px;
  }
  .v-select {
    .vs__dropdown-toggle {
      position: relative;
      border-style: solid;
      border-width: 0 0 thin 0;
      border-top-left-radius: 0.5rem;
      border-top-right-radius: 0.5rem;
      background-color: rgb(245, 248, 249);
      border-color: rgb(186, 191, 194);
      padding: 0.25rem 0.5rem;
      padding-bottom: 0.125rem;
      padding-top: 0.875rem;
      min-height: 1.5rem;
      .vs__actions {
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }
}
</style>